import type { Api } from "./http";
import type { RunRow } from "./runs";

export interface RequestSection {
  state: "available" | "refused";
  count: number | null;
  answerable: number | null;
  /** The live requests due soonest; `title` is a change's own, or a resource's name (#810). */
  items: Array<{ id: string; run_id: string; expires_at: string; title: string | null }>;
}
/** Why the spend gate refused an alarm's investigation (`store/ledger.py`). */
export type SpendRefusalReason = "balance" | "cap" | "no_payment_method";
/** The latest alarm the spend gate refused, while no run has been dispatched since (#1354). */
export interface SpendRefusalNotice {
  reason: SpendRefusalReason;
  refused_at: string;
}
export interface Overview {
  as_of: string;
  window_start: string;
  /** `real` leaves out test alerts' runs, none of which is the first investigation (#985). */
  runs: { total: number; real: number; investigating: number; completed_24h: number };
  changes: RequestSection;
  consent: RequestSection;
  recent: RunRow[];
  spend_refusal?: SpendRefusalNotice | null;
}
export const readOverview = (api: Api): Promise<Overview> =>
  api.get("/api/v1/overview");
